import { api } from "@/APIRequests";
import type { CarePlanResponse } from "@/core/types";

export async function getCarePlan(patientId: string): Promise<CarePlanResponse> {
  return api.sharedTyped.get_care_plan({ params: { showLoader: false }, patientId });
}
